import { render, staticRenderFns } from "./fnSidebar.vue?vue&type=template&id=8ccd456e"
import script from "./fnSidebar.vue?vue&type=script&lang=js"
export * from "./fnSidebar.vue?vue&type=script&lang=js"
import style0 from "@dss/assets/styles/sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports